// The unit's Time Zone city list (SETUP > Date/Time > [Time Zone], param 831).
// The setting is an index into this list, so the table has to match the unit's
// own ordering exactly — position IS the value.
//
// Known imperfectly. A few points were checked against hardware (the first
// entries, the last three, and the neighbourhood of Tokyo: index 139 = "Tokyo",
// which is also the broker's default, and 140 = "Ulaan Bataar"); the rest is
// reconstructed. Entries in between may be wrong, and a wrong entry shows up as
// the wrong city on the unit after a write — recoverable by picking again.
// docs/{en,ja}/known-issues.md states this to users.
//
// Two traps for anyone tempted to tidy this up:
//   - it is NOT strictly alphabetical: "La Paz (Mexico)" precedes
//     "La Paz (Bolivia)". Sorting the array shifts every index from 76 onward.
//   - the names match a Windows time-zone display-name city set older than any
//     published `timezones.json` release ("Ulaan Bataar", no "Tripoli"), so
//     regenerating from that package would silently shift indices.
// Treat the array as fixed data: append nothing, reorder nothing.

/** City names in device order; the array index is the param 831 value. */
export const TIME_ZONE_CITIES: readonly string[] = [
  "Abu Dhabi",
  "Adelaide",
  "Alaska",
  "Almaty",
  "Amman",
  "Amsterdam",
  "Arizona",
  "Astana",
  "Asuncion",
  "Athens",
  "Atlantic Time (Canada)",
  "Auckland",
  "Azores",
  "Baghdad",
  "Baja California",
  "Baku",
  "Bangkok",
  "Beijing",
  "Beirut",
  "Belgrade",
  "Berlin",
  "Bern",
  "Bogota",
  "Brasilia",
  "Bratislava",
  "Brisbane",
  "Brussels",
  "Bucharest",
  "Budapest",
  "Buenos Aires",
  "Cairo",
  "Canberra",
  "Cape Verde Is.",
  "Caracas",
  "Casablanca",
  "Cayenne",
  "Central America",
  "Central Time (US & Canada)",
  "Chennai",
  "Chihuahua",
  "Chongqing",
  "Coordinated Universal Time",
  "Copenhagen",
  "Darwin",
  "Dhaka",
  "Dublin",
  "Eastern Time (US & Canada)",
  "Edinburgh",
  "Ekaterinburg",
  "Fiji",
  "Georgetown",
  "Greenland",
  "Guadalajara",
  "Guam",
  "Hanoi",
  "Harare",
  "Hawaii",
  "Helsinki",
  "Hobart",
  "Hong Kong",
  "Indiana (East)",
  "International Date Line West",
  "Irkutsk",
  "Islamabad",
  "Istanbul",
  "Jakarta",
  "Jerusalem",
  "Kabul",
  "Karachi",
  "Kathmandu",
  "Kolkata",
  "Krasnoyarsk",
  "Kuala Lumpur",
  "Kuwait",
  "Kyiv",
  "La Paz (Mexico)",
  "La Paz (Bolivia)",
  "Lima",
  "Lisbon",
  "Ljubljana",
  "London",
  "Madrid",
  "Magadan",
  "Manaus",
  "Marshall Is.",
  "Mazatlan",
  "Melbourne",
  "Mexico City",
  "Mid-Atlantic",
  "Midway Island",
  "Minsk",
  "Monrovia",
  "Monterrey",
  "Montevideo",
  "Moscow",
  "Mountain Time (US & Canada)",
  "Mumbai",
  "Muscat",
  "Nairobi",
  "New Caledonia",
  "New Delhi",
  "Newfoundland",
  "Novosibirsk",
  "Nuku'alofa",
  "Osaka",
  "Pacific Time (US & Canada)",
  "Paris",
  "Perth",
  "Petropavlovsk-Kamchatsky",
  "Port Louis",
  "Port Moresby",
  "Prague",
  "Pretoria",
  "Quito",
  "Reykjavik",
  "Riga",
  "Riyadh",
  "Rome",
  "Samoa",
  "San Juan",
  "Santiago",
  "Sapporo",
  "Sarajevo",
  "Saskatchewan",
  "Seoul",
  "Singapore",
  "Skopje",
  "Sofia",
  "Solomon Is.",
  "Sri Jayawardenepura",
  "St. Petersburg",
  "Stockholm",
  "Sydney",
  "Taipei",
  "Tallinn",
  "Tashkent",
  "Tbilisi",
  "Tehran",
  "Tijuana",
  "Tokyo",
  "Ulaan Bataar",
  "Urumqi",
  "Vienna",
  "Vilnius",
  "Vladivostok",
  "Volgograd",
  "Warsaw",
  "Wellington",
  "West Central Africa",
  "Windhoek",
  "Yakutsk",
  "Yangon (Rangoon)",
  "Yerevan",
  "Zagreb",
];
